import { StyleSheet } from 'react-native';
import { WebCard, WebCardProps } from './WebCard';

export const SideSectionCard = ({ style, ...props }: SideSectionCardProps) => {
	return <WebCard style={[styles.card, style]} {...props} />;
};

export type SideSectionCardProps = WebCardProps;

const styles = StyleSheet.create({
	card: {
		minWidth: 380,
		maxWidth: 405,
	},
});
